import { createFileRoute } from "@tanstack/react-router"
import { meta } from "@/content"
import { LoginPage } from "@/app"

export const Route = createFileRoute("/(public)/auth/login")({
  component: RouteComponent,
  validateSearch: (search) => search as { email?: string },
  head: () => ({ meta: meta({ title: "Sign In" }) }),
})

function RouteComponent() {
  const { email } = Route.useSearch()

  return <LoginPage email={email} />
}
